import React from "react";
import { Helmet } from "react-helmet";

function HowToMeasureBlinds() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 text-slate-900 leading-relaxed">
      <Helmet>
        <title>How to Measure Blinds | Step-by-Step UK Precision Guide</title>
        <meta name="description" content="Master the art of measuring for made-to-measure blinds. Learn the difference between Recess and Exact sizing to ensure a perfect fit every time." />
      </Helmet>

      <div className="max-w-3xl mb-16">
        <h1 className="text-5xl font-black mb-6">How to <span className="text-blue-600">Measure</span> Blinds</h1>
        <p className="text-xl text-slate-600">
          The difference between a "good fit" and a "perfect fit" is a matter of millimetres. Follow our 2026 industry-standard guide to ensure your custom blinds arrive exactly as they should.
        </p>
      </div>

      <section className="grid lg:grid-cols-2 gap-16 items-start mb-24">
        <div className="space-y-12">
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100">
            <h2 className="text-2xl font-bold mb-4 flex items-center gap-3">
              <span className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm">1</span>
              Choose Your Mount Type
            </h2>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="p-4 border-2 border-blue-50 rounded-xl bg-blue-50/30">
                <p className="font-bold text-sm mb-1">Recess Fit (Inside)</p>
                <p className="text-xs text-slate-500">The blind sits inside the window frame for a neat, flush look.</p>
              </div>
              <div className="p-4 border-2 border-slate-100 rounded-xl">
                <p className="font-bold text-sm mb-1">Exact Fit (Outside)</p>
                <p className="text-xs text-slate-500">The blind overlaps the frame to block more light or cover the window entirely.</p>
              </div>
            </div>
            
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold">The Three-Point Rule</h2>
            <p className="text-slate-600">Windows are rarely perfectly square. To avoid the blind getting stuck, you must measure in three places.</p>
            
            <div className="space-y-4">
              <h3 className="font-bold text-lg">Width: Top, Middle, Bottom</h3>
              <p className="text-sm text-slate-500">Measure the inside width. For Recess fits, record the <strong>narrowest</strong> width.</p>
              
              <h3 className="font-bold text-lg">Height: Left, Centre, Right</h3>
              <p className="text-sm text-slate-500">Measure the height from top to sill. Record the <strong>longest</strong> height (drop).</p>
            </div>
          </div>
        </div>

        <div className="bg-slate-900 text-white p-10 rounded-[3rem] sticky top-8">
          <h3 className="text-2xl font-bold mb-6">Pro Tips for Accuracy</h3>
          <ul className="space-y-6">
            <li className="flex gap-4 italic text-slate-300">
              <span className="text-blue-400">📏</span> "Always use a metal tape measure. Cloth tapes can stretch and lead to errors."
            </li>
            <li className="flex gap-4 italic text-slate-300">
              <span className="text-blue-400">📸</span> "Watch out for obstructions like handles, vents, or phone sockets."
            </li>
          </ul>
          
        </div>
      </section>
    </div>
  );
}

export default HowToMeasureBlinds;